import React, { FC } from 'react'
import Policies from "../../Policies";
import {useTranslation} from "react-i18next";

const SoapPolicies: FC = () => {
    const { t } = useTranslation()

    return (
        <Policies
            showGenerateCsvButton={true}
            header={t('testdata.soap.text')}
            searchPlaceholder={t('testdata.soap.search')}
            helpLink={t('testdata.soap.helpLink')}>
        </Policies>
    )
}

export default SoapPolicies
